class RTMPPushChannelsController {
  constructor($state) {
    'ngInject';
    $state.go('settings.integrations');
  }
}

export default RTMPPushChannelsController;



// WEBPACK FOOTER //
// ./app/pages/settings/rtmp-push-channels.js